function ChildTerm(child) {
	if ( ! child.item.label || child.item.label === "" ) {
		return "";
	}
	return `
		<label class="inline-checkbox" data-term="${child.item.label}">
			<input class="form-checkbox" type="checkbox" value="${child.item.value}" ${ child.item.isRefined ? "checked" : "" }>
			<span class="">${child.item.label} (${child.item.count})</span>
		</label>
	`;
}

export default ChildTerm;